import React from 'react';
import './StatTab.styl';
import chopAtWordBoundary from 'utils/chopAtWordBoundary';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';

export default function StatTab({
  tabConfig,
  values,
  maxLabelLength = Number.MAX_SAFE_INTEGER, // no practical limit by default.
}) {
  const label = chopAtWordBoundary(tabConfig.label, maxLabelLength);
  const needsToolTip = label.length !== tabConfig.label.length;
  const value = tabConfig.summary(values);

  return (
    <div className="rep-stat-tab">
      <div className="label">
        {needsToolTip ? (
          <GenericTooltip closeImmediately hoverBehavior positionTop tooltip={tabConfig.label}>
            {label}
          </GenericTooltip>
        ) : (
          label
        )}
      </div>
      <div className="value">{tabConfig.formatValue(value)}</div>
    </div>
  );
}
